/* global flatpickr moment */

import React, { Component, createRef } from 'react'

function isoToDate(iso) {
  if (!iso) return null
  const m = moment(iso, 'YYYY-MM-DD', true)
  return m.isValid() ? m.toDate() : null
}

function dateToIso(d) {
  return moment(d).format('YYYY-MM-DD')
}

function formatDisplay(iso) {
  if (!iso) return ''
  const m = moment(iso, 'YYYY-MM-DD', true)
  return m.isValid() ? m.format('DD.MM.YYYY') : ''
}

/** Период: один flatpickr (mode: range) с подсветкой диапазона в календаре. */
export default class PeriodRangeField extends Component {
  fromRef = createRef()
  toRef = createRef()
  fp = null

  componentDidMount() {
    this.initPicker()
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.value || {}
    const cur = this.props.value || {}
    if (prev.from !== cur.from || prev.to !== cur.to) {
      this.syncPicker()
    }
  }

  componentWillUnmount() {
    if (this.fp) {
      this.fp.destroy()
      this.fp = null
    }
  }

  openPicker = () => {
    if (this.fp) this.fp.open()
  }

  initPicker() {
    const fromInput = this.fromRef.current
    const toInput = this.toRef.current
    if (!fromInput || typeof flatpickr === 'undefined') return

    const { value, onChange } = this.props
    const from = isoToDate(value?.from)
    const to = isoToDate(value?.to)
    const defaults = []
    if (from) defaults.push(from)
    if (to) defaults.push(to)

    this.fp = flatpickr(fromInput, {
      mode: 'range',
      dateFormat: 'd.m.Y',
      locale: 'ru',
      allowInput: false,
      defaultDate: defaults.length ? defaults : undefined,
      onReady: (_dates, _str, instance) => {
        if (instance.calendarContainer) {
          instance.calendarContainer.classList.add('sigur-flatpickr')
        }
      },
      onChange: (selectedDates) => {
        const f = selectedDates[0] ? dateToIso(selectedDates[0]) : ''
        const t = selectedDates[1] ? dateToIso(selectedDates[1]) : ''
        if (fromInput) {
          fromInput.value = selectedDates[0] ? formatDisplay(f) : ''
        }
        if (toInput) {
          toInput.value = selectedDates[1] ? formatDisplay(t) : ''
        }
        onChange({ from: f, to: t })
      },
    })

    if (toInput) {
      toInput.addEventListener('focus', this.openPicker)
      toInput.addEventListener('click', this.openPicker)
    }

    this.syncDisplay()
  }

  syncPicker() {
    if (!this.fp) return
    const { value } = this.props
    const from = isoToDate(value?.from)
    const to = isoToDate(value?.to)
    if (from && to) {
      this.fp.setDate([from, to], false)
    } else if (from) {
      this.fp.setDate([from], false)
    } else {
      this.fp.clear()
    }
    this.syncDisplay()
  }

  syncDisplay() {
    const fromInput = this.fromRef.current
    const toInput = this.toRef.current
    const { value } = this.props
    if (fromInput) fromInput.value = formatDisplay(value?.from)
    if (toInput) toInput.value = formatDisplay(value?.to)
  }

  render() {
    return (
      <div className="field-range period-range-field">
        <input
          type="text"
          ref={this.fromRef}
          className="form-control field-range-input"
          placeholder="с"
          autoComplete="off"
          readOnly
        />
        <div className="field-range-divider" aria-hidden />
        <input
          type="text"
          ref={this.toRef}
          className="form-control field-range-input"
          placeholder="по"
          autoComplete="off"
          readOnly
        />
      </div>
    )
  }
}
